import { OnInit, EventEmitter } from '@angular/core';
import { ColorModel } from 'src/app/edit/models/color.model';
import { ColorUtils } from '../../libraries/colors/colors';
var ColorPickerComponent = /** @class */ (function () {
    function ColorPickerComponent() {
        this.size = 'normal';
        this.colorSelected = new EventEmitter();
        this.colorHexSelected = new EventEmitter();
    }
    Object.defineProperty(ColorPickerComponent.prototype, "colorHex", {
        get: function () {
            return this.getHexFromColor(this.color);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColorPickerComponent.prototype, "backgroundCSS", {
        get: function () {
            if (this.color) {
                var _a = this.color, red = _a.red, green = _a.green, blue = _a.blue, alpha = _a.alpha;
                return "rgba(" + red * 255 + ", " + green * 255 + ", " + blue * 255 + ", " + alpha + ")";
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    ColorPickerComponent.prototype.ngOnInit = function () {
    };
    ColorPickerComponent.prototype.handleColorPickerChange = function (hexColor) {
        var selectedColor = hexColor ? this.getColorFromHex(hexColor) : null;
        // dispatch color selection
        this.colorSelected.emit(selectedColor);
        this.colorHexSelected.emit(hexColor);
    };
    ColorPickerComponent.prototype.getColorFromHex = function (hexColor) {
        var rgba = ColorUtils.hexToRgba(hexColor, true);
        return new ColorModel(rgba[0], rgba[1], rgba[2], rgba[3]);
    };
    ColorPickerComponent.prototype.getHexFromColor = function (color) {
        if (color) {
            var red = color.red, green = color.green, blue = color.blue, alpha = color.alpha;
            return ColorUtils.rgbaToHex([red, green, blue, alpha], true);
        }
        else {
            return '';
        }
    };
    return ColorPickerComponent;
}());
export { ColorPickerComponent };
